// extracted by mini-css-extract-plugin
export default {"container":"ZoomableImage_container__5rNL2","image":"ZoomableImage_image__OtUn2","zoomed":"ZoomableImage_zoomed__JUfui"};